import React from 'react';
import { withRouter } from 'react-router-dom';

import ArticleContent from '../ArticleContent/index.jsx';

import articleModalService from '../../Services/ArticleModal/index.jsx';
import AjaxService from '../../Services/Ajax/index.jsx'

import Loader from '../../EntryPoints/Loader.jsx';
import entrypoints from '../../EntryPoints/AllEntryPoints.jsx';
class ArticleModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      article: null,
      showContent: false,
      post_id: null,
      post_slug: null,
      isBusy: true,
      articleAnalytics: null
    }
    this.viewPage = this.viewPage.bind(this)
    this.requestPage = this.requestPage.bind(this)
    this.closeArticle = this.closeArticle.bind(this)
    this.routeKey = "slug";
  }

  componentDidMount() {
    window.addEventListener("cs:article", this.viewPage, false);
    this.parseParams()
  }

  parseParams() {
    let params = new URLSearchParams(window.location.search)

    if (params.get(this.routeKey)) {
      this.requestPage(params.get(this.routeKey))
    } else {
      this.setState({
        article: null,
        showContent: false,
        post_id: null,
        post_slug: null,
        isBusy: true
      })
    }
  }

  // update url to use page identifier
  viewPage(event) {
    this.props.history.push(`${window.location.pathname}?${this.routeKey}=${event.detail.slug}`)//${this.routeKey}=${event.detail.id}
    
    // Access analytics data coming from article component
    this.setState({
      articleAnalytics: event.detail.analytics
    })
  }

  // query page
  requestPage(post_slug) {
    this.setState({
      isBusy: true,
      showContent: true
    })
    articleModalService.fetchArticle(post_slug)
      .then(result => {
        if (result) {
          // if we have been given analytics data, then use that in place of
          // what's given to us by the API
          if (this.state.articleAnalytics) {
            result.analytics = this.state.articleAnalytics;
          }

          this.setState({
            isBusy: false,
            article: result
          })
          // loading and rendering all registered entrypoints
          var loader = new Loader(document,entrypoints);
          loader.load();
          // Send event tracking data to GTM
          CSAnalytics("Content Read", result.analytics)

          // trigger pageview
          if("ga" in window){
            ga('send', {
              hitType: 'pageview',
              page: result.permalink
            });
          }

          // trigger twitter widget load
          if("twttr" in window) {
            twttr.widgets.load()
          }
        } else {
          this.setState({
            isBusy: false,
            showContent: false,
            post_id: null,
            post_slug: null
          })
          alert('Error: article not found or you may not have permission to access it!')
        }
      })
      .catch(err => {
        
        var data = 'error=' + err.toString();
    
        AjaxService.post('theme:react-error', data);
        alert('An error has occurred!')
      })
  }

  // update url to remove page identifier
  closeArticle() {
    this.props.history.push(`${window.location.pathname}`)
  }

  // parse params on url change
  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.parseParams()
    }
  }

  render() {
    if (this.state.showContent) {
      return (
        <ArticleContent
          isBusy={this.state.contentBusy}
          onClose={this.closeArticle}
          showContent={true}
          article={this.state?.article}
        />
      );
    } else {
      return null;
    }
  }
}

export default withRouter(ArticleModal);

